import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollTop from './components/ScrollTop/ScrollTop';
import Header from './components/Header/Header';
import Quote from './components/Quote/Quote';
import Why from './components/Why/Why';
import ImageSection from './components/ImageSection/ImageSection';
import AboutUs from './components/AboutUs/AboutUs';
import SecoundImage from './components/SecoundImage/SecoundImage';
import Branches from './components/Branches/Branches';
import Facilities from './components/Facilities/Facilities';
import Gallery from './components/Gallery/Gallery';
import ContactUs from './components/ContactUs/ContactUs';
import Events from './components/Events/Events';
import Staff from  './components/Staff/Staff';
import Location from './components/Location/Location'
import Scroll from "./components/Scroll/Scroll"
import Notification from './components/Notification/Notification';
// import CookieConsent from 'react-cookie-consent';

// import CookieSetter from './components/Cookie/CookieSetter';

const App = () => {
  return (
    <>
    <Router>
      <Navbar />
      <Scroll />
      <Routes>
        <Route 
          exact path="/" 
          element={
            <>
              <Notification/>
              <Header />
              <Quote />
              <Why />
              <ImageSection />
              <AboutUs />
              <SecoundImage />
              <Branches />
              <Quote />
              <Facilities />
              <Gallery />
              <ScrollTop />
              <ContactUs />
            </>
          } 
        />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/branches" element={<Branches />} />
        <Route path="/why-us" element={<Why />} />
        <Route path="/events" element={<Events />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/staff" element={<Staff />} />
        
        {/* Add other routes as needed */}
      </Routes>
      <Location />
      <Footer />
    {/* <CookieConsent
        location="bottom"
        buttonText="I understand"
        cookieName="myAwesomeCookieName"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.{" "}
        <span style={{ fontSize: "10px" }}>Suffah High School E/M</span>
      </CookieConsent> */}
      {/* <CookieSetter /> */}
    </Router>
    </>
  );
}

export default App;
